interface LabeledOption {
  value: any;
  label: string;
}

export interface SelectInputProps<TOption extends object | string | string> {
  value: any;
  options: TOption[] | null;
  multiple: boolean;
  getOptionLabel: (option: TOption) => string;
  getOptionKey: (option: TOption) => string | number;
  remoteMethod?: (searchText: string) => any;
}

export const defaultGetOptionKey = <TOption extends object | string | string>(
  option: TOption,
) => {
  if (typeof option === "string" || typeof option === "number") return option;
  console.log(option);
  throw new Error(
    "Select with non-string options needs to specify getOptionKey.",
  );
};

export const defaultGetLabel = <TOption extends object | string | number>(
  option: TOption,
) => {
  if (typeof option === "string") return option;
  if (typeof option === "number") return option.toString();
  throw new Error(
    "Select with non-string options needs to specify getOptionLabel.",
  );
};
